import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login/Login'
import Register from '@/components/Register/Register'
import Option from '@/components/Home/option'
import RegisterInfo from '@/components/Register/RegisterInfo'
import Home from '@/components/Home/Home'

//线路列表
import toursRoute from '@/components/Vip/Tours/ToursRoute'
import tours from '@/components/Vip/Tours/Tours'

//异常
import notFound from '@/error/404'

//商城
import storeMouder from '@/components/Store/Store'
import storeInfo from '@/components/Store/StoreInfo'

//发放优惠券




import Index from '@/components/Index/index'
import Customer from '@/components/Customer/customerList'
import CustomInfo from '@/components/Customer/customerInfo'
import DataStatis from '@/components/DataStatis/dataStatis'
import Staff from '@/components/Staff/staffList'
import GrantCard from '@/components/Grant/GrantCard/grantCardList'
import GrantReceipt from '@/components/Grant/GrantReceipt/grantReceipt'
import GrantGitf from '@/components/Grant/GrantGift/grantGift'
import GrantProduct from '@/components/Grant/GrantProduct/grantProduct'
import AddDepartMent from '@/components/Department/addDepartment'
import Department from '@/components/Department/department'
import DepartmentInfo from '@/components/Department/departmentInfo'
import AddStaff from '@/components/Staff/addStaff'
import StaffInfo from '@/components/Staff/staffInfo'
import CustPool from '@/components/CustPool/index'
import privacy from '@/components/privacy/privacy'


import clientManagementRouter from './clientManagement'

Vue.use(Router)


export default new Router({
  mode:'history',
  routes: [
    {
      path: '/index',
      name: 'Index',
      component: Index,
      children:[
        {
          path:'',
          redirect:'dataStatis'
        },
        {
          path: 'dataStatis',
          name: 'DataStatis',
          component: DataStatis,
        },
        {
          path: 'customer',
          name: 'Customer',
          component: Customer,
        },
        clientManagementRouter,   //客户管理的路由
        {
          path: 'customInfo',
          name: 'CustomInfo',
          component: CustomInfo,
        },
        {
          path: 'staff',
          name: 'Staff',
          component: Staff,
        },
        {
          path: 'addStaff',
          name: 'AddStaff',
          component: AddStaff,
        },
        {
          path: 'staffInfo',
          name: 'StaffInfo',
          component: StaffInfo,
        },
        {
          path: 'grantCard',
          name: 'GrantCard',
          component: GrantCard,
        },
        {
          path: 'grantReceipt',
          name: 'GrantReceipt',
          component: GrantReceipt,
        },
        {
          path: 'grantGitf',
          name: 'GrantGitf',
          component: GrantGitf,
        },
        {
          path: 'grantProduct',
          name: 'GrantProduct',
          component: GrantProduct,
        },
        {
          path: 'departMent',
          name: 'Department',
          component: Department,
        },
        {
          path: 'addDepartMent',
          name: 'AddDepartMent',
          component: AddDepartMent,
        },
        {
          path: 'departmentInfo',
          name: 'DepartmentInfo',
          component: DepartmentInfo,
        },
        {
          name: 'CustPool',
          path:'CustPool',
          component:CustPool
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Option',
      name: 'Option',
      component: Option
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/RegisterInfo',
      name: 'RegisterInfo',
      component: RegisterInfo
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path:'/toursRoute',
      name:'toursRoute',
      component:toursRoute
    },
    {
      path:'/notFound',
      name:'notFound',
      component:notFound

    },
    {
      path:'/storeInfo',
      name:'storeInfo',
      component:storeInfo
    },
    {
      path:'/tours',
      name:'tours',
      component:tours
    },
    {
      path:'/storeMouder',
      name:'storeMouder',
      component:storeMouder
    },
    {
      path:'/privacy',
      name:'privacy',
      component:privacy
    },
    {
      path:'',
      redirect:'index'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js